import React, { useState } from "react";
import { BankAccountWrapper as Wrapper } from "./style";
import More from "../../assets/images/more.svg";
import BankLogo from "../../assets/images/bankLogo.png";
import Close from "../../assets/images/close.svg";

const BankAccount = ({
  accName,
  accNumber,
  bankName,
  dropDownItem,
  handleDropDown,
  data,
}) => {
  const [dropDown, setDropDown] = useState(false);
  return (
    <Wrapper>
      <div className="bc-left">
        <div className="bc-left-item">
          <div className="bcl-title">Account Name</div>
          <div className="bcl-details">{accName}</div>
        </div>
        <div className="bc-left-item">
          <div className="bcl-title">Account Number</div>
          <div className="bcl-details">{accNumber}</div>
        </div>
      </div>
      <div className="bc-right">
        <div className="bc-right-more">
          <img
            src={dropDown === true ? Close : More}
            alt="more"
            onClick={() => setDropDown(!dropDown)}
            onKeyPress={() => setDropDown(!dropDown)}
            role="presentation"
            tabIndex="-1"
          />

          {dropDown ? (
            <div className="bc-dropdown">
              {dropDownItem?.length
                ? dropDownItem.map((item) => (
                    <div
                      className={`bc-drop-item ${item.style}`}
                      key={item.id}
                      onClick={() => handleDropDown(item?.id, data)}
                    >
                      {item.label}
                    </div>
                  ))
                : ""}
            </div>
          ) : (
            ""
          )}
        </div>
        <div>
          {//bankName
          }
        </div>
      </div>
    </Wrapper>
  );
};

export default BankAccount;
